import { useState } from 'react'
import Cookies from 'js-cookie'
import { successToast } from '../lib/toastAlert'

export function CookiesDisclaimer() {
  const [acceptedAdCookies, setAcceptedAdCookies] = useState(
    Cookies.get('accept_ad_cookies') === 1
  )

  const [acceptedAnalyticsCookies, setAcceptedAnalyticsCookies] = useState(
    Cookies.get('accept_analytics_cookies') === 1
  )

  const handleSubmit = (e) => {
    App.Request.post('/cookies.json', {
      accept_cookie_policy: 1,
      accept_ad_cookies: +acceptedAdCookies,
      accept_analytics_cookies: +acceptedAnalyticsCookies,
    }).then(({ status }) => {
      if (status === 200) {
        successToast()
      }
    })
    e.preventDefault()
  }

  return (
    <div className="container shadow p-3">
      <div className="row">
        <div className="col">
          <form className="mt-3" onSubmit={handleSubmit}>
            <div className="form-check mt-2">
              <label>
                <input
                  type="checkbox"
                  className="form-check-input"
                  defaultChecked
                  value
                  disabled
                />
                <strong>{I18n.t('cookies.necessary_heading')}.</strong>{' '}
                {I18n.t('cookies.necessary_explanation')}.
              </label>
            </div>
            <div className="form-check mt-2">
              <label>
                <input
                  type="checkbox"
                  className="form-check-input"
                  name="acceptedAdCookies"
                  checked={acceptedAdCookies}
                  value={acceptedAdCookies}
                  onChange={() => setAcceptedAdCookies(!acceptedAdCookies)}
                />
                <strong>{I18n.t('cookies.advertising_heading')}.</strong>{' '}
                {I18n.t('cookies.advertising_explanation')}.
              </label>
            </div>
            <div className="form-check mt-2">
              <label>
                <input
                  type="checkbox"
                  className="form-check-input"
                  name="acceptedAnalyticsCookies"
                  checked={acceptedAnalyticsCookies}
                  value={acceptedAnalyticsCookies}
                  onChange={() =>
                    setAcceptedAnalyticsCookies(!acceptedAnalyticsCookies)
                  }
                />
                <strong>{I18n.t('cookies.analytics_heading')}.</strong>{' '}
                {I18n.t('cookies.analytics_explanation')}
              </label>
            </div>
            <button type="submit" className="btn btn-primary float-end rounded-8">
              {I18n.t('submit')}
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}
